import './StatusLicenca.css';

const StatusLicenca = ({ cancelado, expirado }) => {
    let tipo;
    if (cancelado) {
        tipo = 'cancelado';
    } else if (expirado) {
        tipo = 'expirado';
    } else {
        return null;
    }
    const label = tipo === 'cancelado' ? 'Cancelado' : 'Expirado';
    return (
        <div>
            <p className={`status-licenca status-licenca--${tipo}`}>
                {label}
            </p>
        </div>
    );
}

export default StatusLicenca;